import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import StarRateIcon from '@material-ui/icons/Star';
import { vsprintf } from 'sprintf-js';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  priceTitle: {
    fontSize: 15,
    paddingLeft: 5,
  },
  '@media (min-width: 1024px)': {
    width: 100,
  },
  paper: {
    height: 50,
    width: 82,
  },
  paperPrice: {
    height: 50,
    width: 100,
    position: 'relative',
  },
  control: {
    padding: theme.spacing(2),
  },
  sizePaper: {
    width: 150,
  },
});

const hebrewLables = {
  alignType: 'איזון',
  editorScore: 'ציון',
  price: 'מחיר',
  alignTypes: {
    static: 'סטטי',
    electronic: 'אלקטרוני',
    none: 'ללא איזון',
  },
};

class ResultItemPriceRow extends React.Component {
  state = {
    spacing: '1',
  };

  render() {
    const { classes, data, cart } = this.props;
    const { spacing } = this.state;

    const { price, score, alignType } = data;

    let priceText;

    const calculatedPrice = cart.items.reduce((total, item) => {
      const tiresInItem = item.isSet ? (item.isAtvSet ? 4 : 2) : 1;
      return total + price * tiresInItem;
    }, 0);
    priceText = `${vsprintf('%.2f', [calculatedPrice])} ₪`;

    return (
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <Grid
            container
            className={classes.demo}
            justifyContent="center"
            spacing={Number(spacing)}
          >
            <Grid key="editor_score" item>
              <Paper className={classes.paper}>
                <Typography
                  className={classes.priceTitle}
                  variant="h3"
                  component="h3"
                >
                  {hebrewLables.alignType}
                </Typography>
                <div className="result-item-pricing">
                  {hebrewLables.alignTypes[alignType]}
                </div>
              </Paper>
            </Grid>
            <Grid key="customer_score" item>
              <Paper className={classes.paper}>
                <Typography
                  className={classes.priceTitle}
                  variant="h3"
                  component="h3"
                >
                  {hebrewLables.editorScore}
                </Typography>
                <div className="result-item-pricing">
                  <span>{score}</span> <StarRateIcon />
                </div>
              </Paper>
            </Grid>
            <Grid key="price" item>
              <Paper className={classes.paperPrice}>
                <Typography
                  className={classes.priceTitle}
                  variant="h3"
                  component="h3"
                >
                  מחיר
                </Typography>
                <div className="result-item-pricing">{priceText}</div>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

ResultItemPriceRow.propTypes = {
  classes: PropTypes.object.isRequired,
  cart: PropTypes.object,
  data: PropTypes.object.isRequired,
  isSet: PropTypes.bool,
};

export default withStyles(styles)(ResultItemPriceRow);
